<template>
  <div class="common-page driver-workforce-management">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="5">
            <el-form-item label="欠款单编号:">
              <el-input
                style="width: 100%"
                clearable
                v-model="searchForm.debtNo"
                autocomplete="off"
                placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="姓名/电话:">
              <el-input
                style="width: 100%"
                clearable
                v-model="searchForm.keyword"
                autocomplete="off"
                placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="所属机构:">
              <el-select style="width: 100%" clearable v-model="searchForm.companyId" placeholder="请选择">
                <el-option
                  v-for="item in companyData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="车队长:">
              <el-select style="width: 100%" clearable v-model="searchForm.vehicleLeaderId" placeholder="请选择">
                <el-option
                  v-for="item in cheDuiData"
                  :key="item.userId"
                  :label="item.username"
                  :value="item.userId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="欠款类型:">
              <el-select style="width: 100%" clearable v-model="searchForm.debtType" placeholder="请选择">
                <el-option
                  v-for="item in $dict.debtTypeOptions"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="处理状态:">
              <el-select style="width: 100%" clearable v-model="searchForm.debtStatus" placeholder="请选择">
                <el-option
                  v-for="item in $dict.debtStatusOptions"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="欠款时间:">
              <custom-date-range
                :start-date="searchForm.debtTimeStart"
                :end-date="searchForm.debtTimeEnd"
                @update:startDate="(val) => (searchForm.debtTimeStart = val)"
                @update:endDate="(val) => (searchForm.debtTimeEnd = val)"></custom-date-range>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item label="">
              <el-button type="default" round icon="el-icon-search" @click="handleCheck()"></el-button>
              <el-button type="primary" round icon="el-icon-refresh" @click="handleReset()"></el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="search-table-box">
      <div class="list-box">
        <div class="list-box-num">￥{{ dataObj.totalDebt }}</div>
        <div class="list-box-label">总欠款</div>
      </div>

      <div class="list-box">
        <div class="list-box-num">￥{{ dataObj.returned }}</div>
        <div class="list-box-label">已还款</div>
      </div>
      <div class="list-box">
        <div class="list-box-num">￥{{ dataObj.unPaid }}</div>
        <div class="list-box-label">待还款</div>
      </div>
      <div class="list-box">
        <div class="list-box-num">￥{{ dataObj.cancellation }}</div>
        <div class="list-box-label">已废单金额</div>
      </div>
      <div class="list-box">
        <div class="list-box-num">{{ dataObj.unPaidUserNum }}</div>
        <div class="list-box-label">需还款人数</div>
      </div>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:debtAmount="{ row }">{{ row.debtAmount }}元</template>
        <template v-slot:debtType="{ row }">
          {{ getLocalLabel("debtType", row.debtType) }}
        </template>
        <template v-slot:debtStatus="{ row }">
          <span class="common-status status-error" v-if="row.debtStatus === -1">已废单</span>
          <span class="common-status status-confirm" v-if="row.debtStatus === 1">已还款</span>
          <span class="common-status status-pending-order" v-if="row.debtStatus === 0">待还款</span>
        </template>
        <template v-slot:operation="{ row }">
          <span
            class="operate-btn"
            :class="row.debtStatus === 0 ? '' : 'disable-txt'"
            @click.stop="row.debtStatus === 0 ? handleChuLi(row) : ''">
            处理
          </span>
          <span class="operate-btn" @click.stop="openDetail(row)">详情</span>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEdit from "./addOrEdit.vue";
import { deleteInfo, enableUser, getOverview, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import { getCheDuiZhang, getRoleSelect } from "@/views/commonApi";
import { getLocalLabel } from "../../../utils/localDict";
import CustomDateRange from "@/components/CustomDateRange.vue";
export default {
  name: "Staff-management",
  mixins: [tableMixin],
  components: {
    CustomDateRange,
    OperateBox,
    CustomTable,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      searchForm: {
        companyId: "",
        debtNo: "",
        debtStatus: "",
        debtTimeEnd: "",
        debtTimeStart: "",
        debtType: "",
        keyword: "",
        vehicleLeaderId: "",
      },
      dataObj: {},
      cheDuiData: [],
      isImmediatelyGetData: true,
      haveCompany: true,
      tableColumn: [
        {
          label: "欠款单编号",
          prop: "debtNo",
          show: true,
        },
        {
          label: "欠款时间",
          prop: "debtTime",
          show: true,
        },
        {
          label: "所属机构",
          prop: "companyName",
          show: true,
        },
        {
          label: "司机姓名",
          prop: "username",
          show: true,
        },
        {
          label: "司机联系方式",
          prop: "phone",
          show: true,
        },
        {
          label: "车队长",
          prop: "vehicleLeaderName",
          show: true,
        },
        {
          label: "欠款类型",
          prop: "debtType",
          scopeStatus: true,
          show: true,
        },
        {
          label: "欠款金额",
          prop: "debtAmount",
          scopeStatus: true,
          show: true,
        },
        {
          label: "审核状态",
          prop: "debtStatus",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "160px",
          scopeStatus: true,
          show: true,
        },
      ],
    };
  },
  watch: {
    "searchForm.companyId": function (val) {
      this.searchForm.vehicleLeaderId = "";
      this.cheDuiData = [];
      if (val) {
        this.getCheDui(val);
      }
    },
  },
  created() {
    this.getTong();
  },
  mounted() {},
  methods: {
    getLocalLabel,
    handleCheck() {
      this.getTableData();
      this.getTong();
    },
    handleReset() {
      this.searchForm = this.$options.data.call(this).searchForm;
      this.tableOptions.currentPage = 1;
      this.getTong();
      this.searchPage();
    },
    getTong() {
      getOverview(this.searchForm).then((res) => {
        if (res.code === 200) {
          this.dataObj = res.data;
        }
      });
    },
    getCheDui(companyId) {
      getCheDuiZhang(companyId).then((res) => {
        if (res.code === 200) {
          this.cheDuiData = res.data;
        }
      });
    },
    handleChuLi(row) {
      this.$refs.addOrEdit.init("处理", false, row);
    },
    openDetail(row) {
      this.$refs.addOrEdit.init("详情", true, row);
    },
    handleEdit(row) {
      this.$refs.addOrEdit.init(this.searchForm.terminalType, row);
    },
    handleStatus(row) {
      this.$confirm(`确定${!row.status ? "启用" : "禁用"}此用户？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        enableUser({ userId: row.userId, status: row.status ? 0 : 1 }).then(
          (res) => {
            if (res.code === 200) {
              this.getTableData();
            }
          }
        );
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.driver-workforce-management {
  .search-table-box {
    display: flex;
    margin: 0 -0.1rem;
    .list-box {
      width: 20%;
      height: 0.9rem;
      border-radius: 0.08rem;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 0.1rem;
      .list-box-num {
        font-size: 0.24rem;
        color: #000000;
        padding-bottom: 0.1rem;
        font-weight: bold;
      }
      .list-box-label {
        font-size: 0.14rem;
        color: #434343;
      }
    }
  }
  .custom-table-box {
    padding-top: 0.2rem;
  }
}
</style>
